module.exports = __webpack_public_path__ + "img/down03.088fad06.png";